import { OverlayAnnotations } from '@readcloud/common';
import React from 'react';
import { Field, useForm } from 'react-final-form';
import * as yup from 'yup';
import { Forms } from '../..';
import { ColorPickerField } from '../Drawings';
import { SliderInput } from '../Drawings/SliderInput';
import {
  AnnotationEditorFormProps,
  makeAnnotationEditor,
} from '../makeAnnotationEditor';
import { boundingRectOfPaths } from '../rectUtils';
const schema = yup
  .object({
    stroke: yup.string().required(),
    strokeWidth: yup.number().required(),
    paths: yup
      .array(
        yup.object({
          points: yup.array(
            yup.object({
              x: yup.number(),
              y: yup.number(),
            })
          ),
        })
      )
      .required(),
    rect: yup
      .object({
        x: yup.number(),
        y: yup.number(),
        width: yup.number(),
        height: yup.number(),
      })
      .required(),
  })
  .shape(Forms.commonSchemas.commonFields);

const PathAnnotationEditorForm = React.memo(function PathAnnotationEditorForm(
  props: AnnotationEditorFormProps
) {
  const form = useForm();
  const handleStrokeWidthChange = React.useCallback(
    (value: number) => {
      const formState = form.getState();
      const prevBoundingRect = boundingRectOfPaths(
        formState.values.paths,
        formState.values.strokeWidth,
        1
      );
      const boundingRect = boundingRectOfPaths(
        formState.values.paths,
        value,
        1
      );
      const dx = boundingRect.x - prevBoundingRect.x;
      const dy = boundingRect.y - prevBoundingRect.y;
      const dwidth = boundingRect.width - prevBoundingRect.width;
      const dheight = boundingRect.height - prevBoundingRect.height;
      form.change('strokeWidth', value);
      form.change('rect', {
        x: formState.values.rect.x + dx,
        y: formState.values.rect.y + dy,
        width: formState.values.rect.width + dwidth,
        height: formState.values.rect.height + dheight,
      });
      form.change(
        'paths',
        formState.values.paths.map((path: OverlayAnnotations.Path) => ({
          ...path,
          points: path.points.map((point) => ({
            x: point.x - dx,
            y: point.y - dy,
          })),
        }))
      );
    },
    [form]
  );
  return (
    <div className="rc-flex rc-flex-col rc-py-2">
      <Field name="stroke" component={ColorPickerField}>
        <Field
          name="strokeWidth"
          render={(field) => (
            <SliderInput
              min={1}
              max={20}
              step={1}
              label="Thickness"
              value={field.input.value || 1}
              onChange={handleStrokeWidthChange}
            />
          )}
        />
      </Field>
      <div className="rc-py-2"></div>
      <div className="rc-flex rc-flex-col">
        <Forms.commonElements.CommonFields
          showPublisherOptions={props.showPublisherOptions}
          showDescription
        />
      </div>
    </div>
  );
});
export const PathAnnotationEditor = makeAnnotationEditor({
  FormComponent: PathAnnotationEditorForm,
  // @ts-expect-error: This error goes away once "strictNullChecks" are set to true
  schema,
});
